<template lang="html">
    <div class="centerx">


            <a class="text-white-dark" href="#" @click="openPopup">
          <vs-icon icon="play_arrow"></vs-icon>
          <!-- <span class="dot-count vs-avatar--count badgeNumber dot-count-danger" v-if="unreadNotifications>0">{{unreadNotifications}}</span> -->
        </a>

      <vs-popup :title="popupTitle" :active.sync="popupActivo" class="maximize-popup" @close="closePopup">
        <div v-if="!video">
          
         
        </div>
        <div v-else>
          <video ref="videoPlayer" width="100%" height="100%" :autoplay="autoplay" :loop="loop" class="popup-video">
            <source :src="videoSrc" type="video/mp4">
          </video>
        </div>
      </vs-popup>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        popupActivo: false,
        video: false,
        popupTitle: "",
        videoSrc: "",
        autoplay: true,
        loop: true
      };
    },

    methods: {
      updateVideoSrc() {
        const path = this.$route.path;
        if (path === "/customers") {
          this.videoSrc = require("@/assets/videos/video1.mp4");
        } else if (path === "/dashboard") {
          this.videoSrc = require("@/assets/videos/video2.mp4");
        }
      },
      openPopup() {
        this.popupActivo = true;
    this.video = true;
    
    const path = window.location.pathname;
    if (path === "/customers") {
      this.videoSrc = require('@/assets/videos/video1.mp4')
    } else if (path === "/dashboard") {
      this.videoSrc = require('@/assets/videos/video2.mp4')
    }
    else
    {
      this.videoSrc = require('@/assets/videos/video2.mp4')
    }
      },
      showVideo() {
        this.video = true;
      },
      closePopup() {
        setTimeout(() => {

        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
        this.videoSrc = "";
        this.video = false;
    }, 300);


      }
    }
  };
  </script>
  
  <style>
  .popup-video {
    height: 100%;
    width: 100%;
  }
  </style>
  